import axios from 'axios'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { formatISO } from 'date-fns'

const initialState = {
  data: [],
  status: 'idle',
  errors: null,
  last_refresh: null,
  api_tries: 0
}

export const fetchModules = createAsyncThunk(
  'module/fetchModules',
  async (accessToken) => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_DOMAIN}/module`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    )
    return response.data.data
  }
)

export const moduleSlice = createSlice({
  name: 'modules',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchModules.pending, (state, action) => {
        state.status = 'loading'
      })
      .addCase(fetchModules.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.data = action.payload
        state.last_refresh = formatISO(new Date())
        state.api_tries = 0
      })
      .addCase(fetchModules.rejected, (state, action) => {
        state.status = 'failed'
        // Write `errors` (the key initialState declares); the old `state.error` was never read.
        state.errors = action.error.message
        state.api_tries += 1
      })
  },
})

export const selectModules = (state) => state.modules
export default moduleSlice.reducer
